import { render, staticRenderFns } from "./ChatOrderProfileAddressForm.vue?vue&type=template&id=566949aa&scoped=true&"
import script from "./ChatOrderProfileAddressForm.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileAddressForm.vue?vue&type=style&index=0&id=566949aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566949aa",
  null
  
)

export default component.exports